// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__c4-wJ","inverse":"Button_inverse__HIQaO"};